import React, { useEffect, useState } from 'react'
import { MarketCalculusCard } from '../../components/preview/Preview'
import { useDSsummaryTablesData } from '../../store/dataStore'
import McPageHelpers, { REQUEST_STATUSES } from '../mc-components/McPageHelpers'
import { useTranslation } from 'react-i18next'
import { BlockBetween, BlockHead, BlockHeadContent, BlockTitle, McHeatMap } from '../../components/Component'
import { useGlobalStoreData } from '../../store/globalStore'
import { Col, Row, Spinner } from 'reactstrap'
import { BADGE_CODES, TARGET_MARKET_KEYS } from '../../utils/Constants'
import TradeTimeMatrix from '../../components/tradeTimeMatrix/TradeTimeMatrix'
import { useEndpointStatusData } from '../../store/endpointStatus'
import { getCountryName } from '../mc-components/market-overview/MarketOverviewTable/MarketOverviewTable.settings'
import { useSDSsearchParams } from '../../store/searchDataStore'
import BadgeCode from '../../components/badge/BadgeCode'

const SourceCountrySecondTab = ({ isMonthly }) => {
  const { t } = useTranslation()
  const searchParams = useSDSsearchParams()
  const countriesGSD = useGlobalStoreData.countries()
  const summaryTablesData = useDSsummaryTablesData()
  const comtradeSummaryEndpointStatus = useEndpointStatusData.comtradeSummary()

  const [mapData, setMapData] = useState({ monthlyImport: [], yearlyImport: [], monthlyExport: [], yearlyExport: [] })

  useEffect(() => {
    const monthlyImport = McPageHelpers.generateTargetMapData(summaryTablesData?.importTabs?.tab2?.mapMonthly, countriesGSD, TARGET_MARKET_KEYS.LAST_IMPORT) || []
    const yearlyImport = McPageHelpers.generateTargetMapData(summaryTablesData?.importTabs?.tab2?.mapYearly, countriesGSD, TARGET_MARKET_KEYS.LAST_IMPORT) || []
    const monthlyExport = McPageHelpers.generateTargetMapData(summaryTablesData?.importTabs?.tab2?.mapMonthly, countriesGSD, TARGET_MARKET_KEYS.LAST_EXPORT) || []
    const yearlyExport = McPageHelpers.generateTargetMapData(summaryTablesData?.importTabs?.tab2?.mapYearly, countriesGSD, TARGET_MARKET_KEYS.LAST_EXPORT) || []
    setMapData({
      monthlyImport,
      yearlyImport,
      monthlyExport,
      yearlyExport
    })
  }, [summaryTablesData])

  const currentImportData = isMonthly ? mapData.monthlyImport : mapData.yearlyImport
  const currentExportData = isMonthly ? mapData.monthlyExport : mapData.yearlyExport
  const currentTableData = isMonthly ? summaryTablesData?.importTabs?.tab2?.monthly : summaryTablesData?.importTabs?.tab2?.yearly

  if (comtradeSummaryEndpointStatus === REQUEST_STATUSES.REQUESTED) {
    return <MarketCalculusCard>
      <div className="d-flex flex-row justify-content-center align-items-center my-5">
        <Spinner color="primary"/>
      </div>
    </MarketCalculusCard>
  }

  return (
    <MarketCalculusCard>
      <div style={{ padding: 20 }}>
        <BlockHead size="sm">
          <BlockBetween className="center">
            <BlockHeadContent className="d-flex flex-col justify-center align-center">
              <BlockTitle className="center" tag="h5">
                {getCountryName(searchParams.countryToExport, countriesGSD, 'country_code')} - {t('worldTabs.secondTabHeader')}
              </BlockTitle>
              <BadgeCode color="light" text={BADGE_CODES.SOURCE_TABLE_11}/>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Row className="g-3">
          <Col lg={6}>
            <McHeatMap
              chartId="world-tab2-heatmap-1"
              chartData={currentImportData}
              code={'H-OT-08'}
              height={500}
            />
          </Col>
          <Col lg={6}>
            <McHeatMap
              chartId="world-tab2-heatmap-2"
              chartData={currentExportData}
              code={'H-OT-09'}
              height={500}
            />
          </Col>
        </Row>
      </div>
      {currentTableData && <TradeTimeMatrix key="world-tab2-table" data={currentTableData}/>}
    </MarketCalculusCard>
  )
}

export default SourceCountrySecondTab
